export const engagementFormSagaActionTypes = {
  callGetFormFieldsEngagementSaga: "callGetFormFieldsEngagementSaga",
  callSubmitFormEngagementSaga: "callSubmitFormEngagementSaga",
  callUpdateFormEngagementSaga: "callUpdateFormEngagementSaga",
  callGetEngagementSubmissionsSaga: "callGetEngagementSubmissionsSaga",
  callGetEngagementByIdSaga: "callGetEngagementByIdSaga",
  callReviewEngagementSaga: "callReviewEngagementSaga",
  callDeleteEngagementSaga: "callDeleteEngagementSaga",
};

export const getFormFieldsEngagementSagaAction: () => {
  type: string;
} = () => {
  return {
    type: engagementFormSagaActionTypes.callGetFormFieldsEngagementSaga,
  };
};

export type submitFormEngagementSagaActionPayloadType = {
  source: "Engagement";
  submitted_by: number;
  data: Record<string, any>;
};

export type updateFormEngagementSagaActionPayloadType = {
  source: "Engagement";
  submitted_by: number;
  data: Record<string, any>;
  engagement_id: string;
};

export const submitFormEngagementSagaAction: (payload: submitFormEngagementSagaActionPayloadType) => {
  type: string;
  payload: submitFormEngagementSagaActionPayloadType
} = (payload) => {
  return {
    type: engagementFormSagaActionTypes.callSubmitFormEngagementSaga,
    payload: payload
  };
};

export const updateFormEngagementSagaAction: (payload: updateFormEngagementSagaActionPayloadType) => {
  type: string;
  payload: updateFormEngagementSagaActionPayloadType
} = (payload) => {
  return {
    type: engagementFormSagaActionTypes.callUpdateFormEngagementSaga,
    payload: payload
  };
};

export const getEngagementSubmissionsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: engagementFormSagaActionTypes.callGetEngagementSubmissionsSaga,
  };
};

export const getEngagementByIdSagaAction: (engagementId: string) => {
  type: string;
  payload: string;
} = (engagementId) => {
  return {
    type: engagementFormSagaActionTypes.callGetEngagementByIdSaga,
    payload: engagementId,
  };
};

export type reviewEngagementSagaActionPayloadType = {
  engagementId: string;
  review_status: number;
};

export const reviewEngagementSagaAction: (payload: reviewEngagementSagaActionPayloadType) => {
  type: string;
  payload: reviewEngagementSagaActionPayloadType
} = (payload) => {
  return {
    type: engagementFormSagaActionTypes.callReviewEngagementSaga,
    payload: payload
  };
};

export type deleteEngagementSagaActionPayloadType = {
  engagementId: string;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const deleteEngagementSagaAction: (payload: deleteEngagementSagaActionPayloadType) => {
  type: string;
  payload: deleteEngagementSagaActionPayloadType
} = (payload) => {
  return {
    type: engagementFormSagaActionTypes.callDeleteEngagementSaga,
    payload: payload
  };
};